import { Box } from "@chakra-ui/react";
import { FC } from "react";

import {
  FeatureCard,
  FeatureGrid,
  PageCta,
  PageHero,
  PageSection,
  SectionHeading,
  usePageTitle,
} from "./components";

export const VoorProvincies: FC = () => {
  usePageTitle("BROSTAR voor Provincies");

  return (
    <Box>
      <PageHero
        title="BROSTAR voor Provincies"
        subtitle="Provincies spelen een centrale rol in het grondwaterbeheer en zijn bronhouder voor provinciaal grondwatermonitoringsdata. BROSTAR ondersteunt u bij een correcte en tijdige aanlevering aan de BRO."
      />

      <PageSection>
        <SectionHeading>Ondersteuning voor provinciale bronhouders</SectionHeading>
        <FeatureGrid>
          <FeatureCard title="In de praktijk: Noord-Brabant">
            Voor de provincie Noord-Brabant leveren we alle grondwaterstanden aan de BRO, waarbij
            Brabant Water de validatie uitvoert. Daarnaast levert de provincie via BROSTAR ook haar
            grondwaterkwaliteitsgegevens (GAR) aan.
          </FeatureCard>
          <FeatureCard title="Provinciaal meetnetbeheer">
            Het bijhouden van een meetnet gaat nog lang niet altijd goed. Een meetnet kan namelijk
            door de tijd van samenstelling wisselen, en wanneer buizen elkaar vervangen om een
            bepaalde meetbehoefte te vervullen, kan de naam behouden worden. Dit zorgt ervoor dat
            rapporten over uw meetnet duidelijk te volgen zijn. Binnen BROSTAR kunt u eenvoudig
            wijzigingen in uw meetnet bijhouden, en zo een duidelijk overzicht behouden van de
            geschiedenis van uw meetnet.
          </FeatureCard>
          <FeatureCard title="Grondwaterkwaliteitsonderzoek">
            De provincies zijn de belangrijkste leveranciers van grondwaterkwaliteitsmetingen (GAR)
            aan de BRO. BROSTAR biedt een eenvoudige manier om deze gegevens aan te leveren, zodat u
            zich kunt richten op het uitvoeren van het onderzoek.
          </FeatureCard>
          <FeatureCard title="Eén applicatie voor alle afdelingen">
            Binnen een provincie zijn er vaak meerdere afdelingen die grondwaterdata aanleveren aan
            de BRO. Met BROSTAR kunnen al deze afdelingen dezelfde applicatie gebruiken, waardoor er
            minder afhankelijkheid is van verschillende leveranciers, en er een eenduidige manier
            is. Of een peilbuis nou geregistreerd wordt voor een vergunning, of voor het eigen
            grondwatermeetnet, dat maakt niet uit.
          </FeatureCard>
          <FeatureCard title="Eenvoudig in te zetten">
            Hoewel het mogelijk is een automatische koppeling te bouwen, is het altijd mogelijk om
            BROSTAR voor een deel van uw verantwoordelijkheden in te zetten. Zo kan het zijn dat uw
            leverancier niet in staat is correcties of verwijder berichten te sturen, met BROSTAR
            heeft u zelf altijd een laagdrempelige manier om dit soort berichten te versturen,
            zonder dat u hiervoor een koppeling hoeft te bouwen.
          </FeatureCard>
          <FeatureCard title="Eenvoudig te leren">
            BROSTAR heeft een beperkte set aan functionaliteiten, en hierdoor is het ook eenvoudig
            om te leren. Nieuwe medewerkers kunnen zonder veel moeite aan de slag, en na enkele
            keren de applicatie gebruikt te hebben zullen ze er al snel wegwijs in zijn. Daarnaast
            is onze servicedesk altijd beschikbaar om vragen te beantwoorden, en kunnen we ook
            trainingen verzorgen wanneer hier behoefte aan is.
          </FeatureCard>
          <FeatureCard title="Gedeelde oplossing, voor langdurige samenwerking">
            Meerdere organisaties geloven in BROSTAR, hierdoor is de levensduur van de applicatie
            gewaarborgd. We blijven continu doorontwikkelen, en staan altijd open voor feedback en
            suggesties.
          </FeatureCard>
        </FeatureGrid>
      </PageSection>

      <PageCta
        title="Provinciale BRO-aanlevering vereenvoudigd"
        body="Ontdek hoe provincies BROSTAR inzetten voor betrouwbaar en schaalbaar grondwaterbeheer."
      />
    </Box>
  );
};
